export const API = 'https://crm.jpnt.tech/api/'
export const APIActivity = 'https://srv-status.jpnt.tech/api/'
export const APIActivityV2 = 'https://srv-status.jpnt.tech/api/v2/'

export const drawerWidth = 230

export const googleAccountClientId = '702973847375-cjpj5g3rb233g4m54ohbde2ns1donn8u.apps.googleusercontent.com'
export const googleTagManagerId = 'GTM-W8HKDM6'
export const trackJSToken = 'd97621db1b3a407d831389aff4ed5f1b'
